export const assetSubClassConstants = {
  API_INSERT: '/api/class/subclass/insert',
  API_UPDATE: '/api/class/subclass/update',
  API_DELETE: '/api/class/subclass/delete',
  API_GET: '/api/class/subclass/',
  API_GETALL: '/api/class/subclass/getall',

  INSERT_REQUEST: 'ASSET_SUBCLASS_INSERT_REQUEST',
  INSERT_SUCCESS: 'ASSET_SUBCLASS_INSERT_SUCCESS',
  INSERT_FAILURE: 'ASSET_SUBCLASS_INSERT_FAILURE',

  UPDATE_REQUEST: 'ASSET_SUBCLASS_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'ASSET_SUBCLASS_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'ASSET_SUBCLASS_UPDATE_FAILURE',

  DELETE_REQUEST: 'ASSET_SUBCLASS_DELETE_REQUEST',
  DELETE_SUCCESS: 'ASSET_SUBCLASS_DELETE_SUCCESS',
  DELETE_FAILURE: 'ASSET_SUBCLASS_DELETE_FAILURE',

  GET_REQUEST: 'ASSET_SUBCLASS_GET_REQUEST',
  GET_SUCCESS: 'ASSET_SUBCLASS_GET_SUCCESS',
  GET_FAILURE: 'ASSET_SUBCLASS_GET_FAILURE',

  GETALL_REQUEST: 'ASSET_SUBCLASS_GETALL_REQUEST',
  GETALL_SUCCESS: 'ASSET_SUBCLASS_GETALL_SUCCESS',
  GETALL_FAILURE: 'ASSET_SUBCLASS_GETALL_FAILURE',

  RESET: 'ASSET_SUBCLASS_RESET',
  SERVICE: 'ASSET_SUBCLASS_SERVICE',
};
